import { EmptyState } from '../../components/ui';
import Turno from './Turno';
import './MisTurnos.css';

export default function TurnosPasados({ pasados }) {
  return (
    <section className="mis-turnos-section">
      <h2>Turnos pasados</h2>
      {pasados.length === 0 ? (
        <EmptyState title="No hay turnos en los últimos 3 meses." />
      ) : (
        <div className="mis-turnos-grid">
          {pasados.map((turno) => (
            <Turno key={turno.id} turno={turno} />
          ))}
        </div>
      )}
    </section>
  );
}